
import * as ENV   from '../util/env';
import classnames from 'classnames';
import PropTypes  from 'prop-types';
import React      from 'react';

const Link = React.forwardRef(({ children, className = '', onClick, target, external, ...props }, ref) => {
  const linkTarget    = target || getTarget(external);
  const linkClassName = classnames(className, { external });
  const rel           = external ? 'noopener noreferrer' : '';

  function handleClick(event) {
    // In Phonegap if the link is a external one framework7 calls InAppBrowser and
    // that triggers a routeChange in f7's router. Because the external route doesn't
    // match any of our routes this cause the `NotFoundPage` to show. We set this flag
    // in `true` and then we read it in the `routesBeforeEnter` middleware.
    // More info about the issue in: https://github.com/broadly/broadly/issues/3137
    const { href }   = props;
    const isHTTPLink = /^((http|https):\/\/)/.test(href);
    if (isHTTPLink && external && ENV.isCordova()) {
      window.isOpeningExternalLink = true;
      setTimeout(() => {
        window.isOpeningExternalLink = false;
      });
    }

    if (onClick)
      onClick(event);
  }

  return (
    <a
      {...props}
      onClick={handleClick}
      className={linkClassName}
      target={linkTarget}
      rel={rel}
      ref={ref}
    >
      {children}
    </a>
  );
});

Link.propTypes = {
  children:  PropTypes.node,
  className: PropTypes.string,
  target:    PropTypes.string,
  external:  PropTypes.bool
};

export default Link;


export function getTarget(external) {
  if (!external)
    return null;

  if (ENV.isCordova())
    return '_system';
  else
    return '_blank';
}


export function openExternalLink(url) {
  const isCordova = ENV.isCordova();

  // Framework 7 comes with the cordova InAppBrowser plugin. That is why the
  // plugin is not registered on the package.json
  if (isCordova)
    window.cordova.InAppBrowser.open(url, '_system');
  else
    window.open(url, '_blank');
}
